import { Disclaimer } from "../components/Disclaimer";
import { PageHeader } from "../components/PageHeader";

export function Terms() {
  return (
    <>
      <PageHeader
        eyebrow="الشروط والتنبيهات"
        title="شروط الاستخدام وحدود الخدمة"
        description="توضح هذه الصفحة حدود الخدمة في المرحلة الحالية والتنبيهات المهمة حول طبيعة التقييم."
      />
      <section className="py-20">
        <div className="container max-w-4xl space-y-8">
          <Disclaimer />
          <div className="space-y-6 text-lg leading-10 text-graphite">
            <p>
              تقتصر الخدمة على التقييم الهندسي للحالة الفنية والأضرار وتكلفة
              الإصلاح ضمن نطاق العمل المحدد، ولا تشمل تقدير القيمة السوقية
              للعقار أو أعمال الوساطة أو إصدار فواتير ضريبية رسمية من داخل
              المنصة.
            </p>
            <p>
              لا تتضمن المرحلة الحالية بوابة عملاء، تتبع حالة للعميل، دفعاً
              إلكترونياً، تكاملاً مع الزكاة والضريبة والجمارك، أو إصدار PDF آلي
              من الخادم.
            </p>
            <p>
              التقارير في المرحلة الحالية تُعد كصفحات HTML قابلة للطباعة، ويمكن
              للإدارة استخدام المتصفح لحفظها كملفات PDF عند الحاجة.
            </p>
            <p>
              تُخزن مرفقات PDF بصيغة مشفرة في التخزين الخاص. وعند انتهاء مدة
              الاحتفاظ، تقوم المنصة بإتلاف مفتاح فك التشفير الخاص بالملف ومحاولة
              حذف الكائن من التخزين، ولا تُنشر المرفقات بروابط عامة. وبعد إتلاف
              المفتاح لا يكون محتوى الملف قابلاً للقراءة عبر المنصة.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
